import { render } from "./TableShip_agents.vue?vue&type=template&id=6e8497ec&scoped=true"
import script from "./TableShip_agents.vue?vue&type=script&lang=js"
export * from "./TableShip_agents.vue?vue&type=script&lang=js"

import "./TableShip_agents.vue?vue&type=style&index=0&id=6e8497ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8497ec"]])

export default __exports__